import React from 'react'; // eslint-disable-line no-unused-vars
import reactDom from '../../../common/react/dom/index';
import WidgetAreeTematiche from '../../../components/frontend/widget';

export default function init() {
	reactDom(<WidgetAreeTematiche />, 'js-widget');
}
